/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Virtual Job Experience
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import App from './App.vue';

// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import Tabs from '../src/components/Tabs';
import Tab from '../src/components/Tab';

Vue.use(Vuesax);

// vuesax's <vs-popup> ships without dialog semantics or keyboard handling; this adds them
// to every instance. Registered after Vue.use(Vuesax) so the component exists.
import vsPopupA11y from '@/mixins/vsPopupA11y';
// vuesax's form controls render their visible text as a sibling of the native input rather
// than a <label>, leaving every one of them unnamed. This derives a name from what is
// already on screen.
import vuesaxFormA11y from '@/mixins/vuesaxFormA11y';
// Repairs for rendered markup the app does not own (vuesax icons, collapses, $vs.dialog,
// list titles) and for the colour-only answer marking. Runs once the app has mounted.
import installA11yDom from '@/utils/a11yDom';

Vue.mixin(vsPopupA11y);
Vue.mixin(vuesaxFormA11y);
Vue.component(Tabs.name, Tabs);
Vue.component(Tab.name, Tab);
// axios
import axios from './axios.js';

Vue.prototype.$http = axios;

import VueAccessibleDatepicker from 'vue-accessible-datepicker';

Vue.use(VueAccessibleDatepicker);

// Filters
/*import './filters/filters.js'*/

// Theme Configurations
import '../themeConfig.js';

// Globally Registered Components
import './globalComponents.js';

// Styles: SCSS
import './assets/scss/main.scss';

// Tailwind
import '@/assets/css/main.css';

// Vue Router
import router from './router/router';

// Vuex Store
import store from './store/store';

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer';

Vue.use(VueHammer);

// VeeValidate
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

// Feather font icon
require('./assets/css/iconfont.css');

import ReactiveProvide from 'vue-reactive-provide';

Vue.use(ReactiveProvide);

// Vue select css
// Note: In latest version you have to add it separately
import 'vue-select/dist/vue-select.css';

import idleTimeout from './idleTimeout';

const loginType = localStorage.getItem('login_type');
let useIdleTimeout = false;
let timeoutIdle = 300;
if (loginType == 'student') {
  useIdleTimeout = true;
  timeoutIdle = 1200; //600 //15 mins = 900 sec - 300 for popup
} else if (loginType == 'teacher') {
  useIdleTimeout = true;
  timeoutIdle = 3300; //3300 //60 mins = 3600 sec - 300 for popup
}
if (useIdleTimeout) {
  // eslint-disable-next-line no-unused-vars
  let idleTimeoutInstance = idleTimeout({
    redirectUrl: '/' + loginType + '/logout', // redirect to this url. Set this value to YOUR site's logout page.
    idleTimeLimit: timeoutIdle,
    idleCheckHeartbeat: 15,
    dialogTitle: 'Account Inactivity...',
    dialogText:
      'Due to account inactivity, you will be logged out in 5 minutes.\nIf you wish to remain logged in, click the button below.',
    dialogDisplayLimit: 300,
    sessionKeepAliveTimer: false,
  });
}
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
Vue.use(VuePlyr);
/*import IdleVue from "idle-vue";
const eventsHub = new Vue();
const loginType = localStorage.getItem('login_type');
let useIdleTimeout = false;
let timeoutIdle = 3000;
if(loginType == 'student') {
  useIdleTimeout = true;
  timeoutIdle = 15*60*1000; //15
}
else if(loginType == 'teacher') {
  useIdleTimeout = true;
  timeoutIdle = 60*60*1000; //60
}
if(useIdleTimeout) {
  Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: timeoutIdle, // 3 seconds
    startAtIdle: false
  });
}*/

/*Vue.use(require('vue-pusher'), {
  api_key: 'ed90126b6337114fd956',
  options: {
    cluster: 'ap4',
    encrypted: true,
  }
});*/

Vue.config.productionTip = false;

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

// WCAG SC 2.2.1 Timing Adjustable (audit 29.1, 29.2 - "Message fades away"). A toast that
// disappears on its own gives the user no way to finish reading it. These defaults give
// every toast an always-visible dismiss control and stop the countdown while the user is
// hovering, or while the window does not have focus. Error toasts additionally never
// auto-dismiss - see toastOptions() below.
Vue.use(Toast, {
  toastClassName: 'custom-toast',
  position: 'bottom-center',
  // Nothing auto-dismisses: me2 asks that messages remain until the user dismisses them.
  timeout: false,
  closeButton: 'button',
  showCloseButtonOnHover: false,
  // me2: 'update the label for the close button to "Close message" as this makes it clear
  // to screen reader users what portion of the page is removed'.
  accessibility: { toastRole: 'alert', closeButtonLabel: 'Close message' },
  closeOnClick: true,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  draggable: false,
});

Vue.filter('blob_url', (path) => {
  return $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL + '/' + path;
});

new Vue({
  router,
  store,
  components: { app: App },
  render: (h) => h(App),
  mounted() {
    installA11yDom(document.body);
  },
}).$mount('#app');
